/* globals geoip2 */
import cookies from 'js-cookie';
import iso3116 from '../helpers/iso3116';
import { getDebugQueryParam } from '../../lib/query-params';

const COUNTRY_SET_EVENT_NAME = 'sk:country-set';

function getCountryCodeFromOptimizely() {
  if (cookies.get('_optimizely_iso3166')) return;
  const optimizely = window.optimizely || [];
  if (
    optimizely.data &&
    optimizely.data.visitor &&
    optimizely.data.visitor.location
  ) {
    const visitorCountryAlpha3 = iso3116.convert2To3(
      optimizely.data.visitor.location.country
    );
    cookies.set('_optimizely_iso3166', visitorCountryAlpha3);
  }
}

// trigger event, so that promo stripe and country selector stripe can listen for it
// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
// don't use jQuery custom events, since they do not work for some reason
function triggerCountryCode(countryCode) {
  const event = document.createEvent('Event');
  const debugCountryCode = getDebugQueryParam('country');
  if (!event.shopkeep) {
    event.shopkeep = {
      countryCode: debugCountryCode || countryCode
    };
  }
  event.initEvent(COUNTRY_SET_EVENT_NAME, true, true);
  window.dispatchEvent(event);
}

function listenForCountryCode(callback) {
  window.addEventListener(
    COUNTRY_SET_EVENT_NAME,
    (e) => {
      const countryCode = e.shopkeep ? e.shopkeep.countryCode : '';
      callback(countryCode);
    },
    false
  );
}

function getCountryCodeFromCookie() {
  // _sk_countryCode is set via PHP & Cloudflare headers
  const countryCode = cookies.get('_sk_countryCode');
  if (countryCode) {
    triggerCountryCode(countryCode);
    return;
  }
}

const countryCode = {
  init() {
    getCountryCodeFromCookie();
    getCountryCodeFromOptimizely();
  },
  listenForCountryCode
};

export default countryCode;
